import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {
    Box,
    CloseButton,
    Dialog,
    Flex,
    Grid,
    GridItem,
    Icon,
    IconButton,
    Image,
    Text,
} from "@chakra-ui/react";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react/dist/ssr";
import { useMemo, useRef, useState } from "react";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import ButtonCompartir from "@/components/fichas/buttonCompartir";

const CentralBanner = ({ dataDevelopment, city, session, saveDevFavorites, userFavorites }) => {
    const swiperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (image) => {
        setSelectedImage(image);
        setIsOpen(true);
    };

    //Validar si el desarrollo es favorito
    const isFavorite = useMemo(() => {
        return userFavorites?.some((fav) => fav.development_id === dataDevelopment.development_id);
    }, [userFavorites]);

    return (
        <>
            <Grid
                templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }}
                gap={4}
                pt={{ base: "10vh", md: 14 }}
                alignItems="center"
            >
                <GridItem display="flex" alignItems="center" colSpan={1}>
                    {dataDevelopment?.extra_props?.logo && (
                        <Image
                            src={dataDevelopment?.extra_props?.logo}
                            alt="develop"
                            maxH="7vh"
                            maxW={{ base: "25vw", md: "10vw" }}
                        />
                    )}
                </GridItem>

                <GridItem display="flex" alignItems="initial" colSpan={1}>
                    <Text
                        px={{ base: "0", md: "1vw", lg: "5vw" }}
                        ml={{ base: "auto", md: "auto" }}
                        mr={{ base: "none", md: "auto" }}
                        fontWeight={700}
                        fontSize={{ base: "lg", md: "2xl" }}
                        textAlign="center"
                    >
                        {dataDevelopment?.name
                            ?.toLocaleLowerCase("es")
                            .replace(/(^|\s)\p{L}/gu, (match) => match.toLocaleUpperCase("es")) ||
                            ""}
                    </Text>
                </GridItem>

                <GridItem
                    display="flex"
                    justifyContent={{ base: "center", md: "flex-end" }}
                    alignItems="center"
                    colSpan={{ base: 2, md: 1 }}
                    flexShrink={0}
                >
                    <Flex gap={5}>
                        <Box
                            align="center"
                            cursor="pointer"
                            _hover={{ bg: "gray.100" }}
                            _active={{ bg: "gray.200" }}
                            borderRadius="md"
                        >
                            <ButtonCompartir
                                icon="https://media.grupoguia.mx/assets/home-page/fichas/compartir+2.svg"
                                url={`https://grupoguia.mx/desarrollo/${city && city !== dataDevelopment?.name.toLowerCase().replaceAll(" ", "").replaceAll("ú", "u").replaceAll("ó", "o").replaceAll("í", "i").replaceAll("é", "e").replaceAll("á", "a") ? `${city}/` : ""}${dataDevelopment?.name.toLowerCase().replaceAll(" ", "").replaceAll("ú", "u").replaceAll("ó", "o").replaceAll("í", "i").replaceAll("é", "e").replaceAll("á", "a")}`}
                                fontsize="sm"
                            >
                                Compartir
                            </ButtonCompartir>
                        </Box>
                        {session && (
                            <Flex
                                gap={3}
                                align="center"
                                cursor="pointer"
                                _hover={{ bg: "gray.100" }}
                                _active={{ bg: "gray.200" }}
                                p={2}
                                borderRadius="md"
                                onClick={(e) => {
                                    e.preventDefault();
                                    saveDevFavorites(null, dataDevelopment?.development_id);
                                }}
                            >
                                <Image
                                    src={
                                        isFavorite
                                            ? "https://media.grupoguia.mx/assets/apps-icons/favorite_active.svg"
                                            : "https://media.grupoguia.mx/assets/apps-icons/favorite.svg"
                                    }
                                    alt="favorite"
                                    maxH="3vh"
                                />

                                <Text fontWeight="400" fontSize="sm" color="black" textAlign="end">
                                    Favorito
                                </Text>
                            </Flex>
                        )}
                    </Flex>
                </GridItem>
            </Grid>
            <Box position="relative">
                <Swiper
                    ref={swiperRef}
                    modules={[Pagination, Autoplay]}
                    pagination={{
                        clickable: true,
                        renderBullet: (index, className) =>
                            `<span class="${className} custom-bullet"></span>`,
                    }}
                    spaceBetween={10}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    navigation={false}
                    className="relative"
                >
                    {dataDevelopment?.images?.map((image, idx) => (
                        <SwiperSlide key={idx}>
                            <Box
                                position="relative"
                                width="100%"
                                height="75vh"
                                borderRadius="lg"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={() => openModal(image.url)} // Abrir modal con imagen seleccionada
                            >
                                <Image
                                    src={image.url}
                                    alt={`Slide ${idx}`}
                                    objectFit="cover"
                                    width="100%"
                                    height="100%"
                                />

                                <Box
                                    position="absolute"
                                    bottom="0"
                                    left="0"
                                    width="100%"
                                    height="50%"
                                    bgGradient="to-t"
                                    gradientFrom="blackAlpha.700"
                                    gradientTo="transparent"
                                    pointerEvents="none"
                                />
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Botón Anterior */}
                <IconButton
                    onClick={() => swiperRef.current.swiper.slidePrev()}
                    aria-label="Previous slide"
                    position="absolute"
                    top="50%"
                    left="20px"
                    transform="translateY(-50%)"
                    background="white"
                    borderRadius="full"
                    boxShadow="md"
                    _hover={{ background: "gray.300" }}
                    zIndex={1}
                >
                    <Icon boxSize={4} color="#BBBBBB">
                        <CaretLeftIcon weight="bold" />
                    </Icon>
                </IconButton>

                {/* Botón Siguiente */}
                <IconButton
                    onClick={() => swiperRef.current.swiper.slideNext()}
                    aria-label="Next slide"
                    position="absolute"
                    top="50%"
                    right="20px"
                    transform="translateY(-50%)"
                    background="white"
                    borderRadius="full"
                    boxShadow="md"
                    _hover={{ background: "gray.300" }}
                    zIndex={1}
                >
                    <Icon boxSize={4} color="#BBBBBB">
                        <CaretRightIcon weight="bold" />
                    </Icon>
                </IconButton>

                {/* Modal de Imagen */}
                <Dialog.Root
                    open={isOpen}
                    onOpenChange={() => setIsOpen(false)}
                    isCentered
                    placement="center"
                    size={{ base: "sm", md: "xl" }}
                >
                    <Dialog.Backdrop />
                    <Dialog.Positioner>
                        <Dialog.Content bg="blackAlpha.900" w="90vw">
                            <Dialog.CloseTrigger asChild>
                                <CloseButton
                                    size="md"
                                    bg="gray"
                                    borderRadius="md"
                                    _hover={{ background: "#F0F0F0" }}
                                />
                            </Dialog.CloseTrigger>
                            <Dialog.Body display="flex" justifyContent="center" alignItems="center">
                                {selectedImage && (
                                    <Image
                                        src={selectedImage}
                                        alt="modal_image"
                                        maxH="80vh"
                                        maxW="100%"
                                        objectFit="contain"
                                    />
                                )}
                            </Dialog.Body>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Root>

                {/* Estilos CSS personalizados */}
                <style>
                    {`
                    .swiper-pagination-bullet {
                        width: 10px;
                        height: 10px;
                        border: 2px solid white;
                        background: transparent;
                        opacity: 1;
                        transition: all 0.3s ease;
                    }
                    .swiper-pagination-bullet-active {
                        background: white;
                        transform: scale(1.2);
                    }
                    `}
                </style>
            </Box>
        </>
    );
};

export default CentralBanner;
